import { PublicClientApplication } from '@azure/msal-browser'
import { EventType } from '@azure/msal-browser';
import { getSettings } from './settings'

let fmMsalInstance;

const fmAuthConfig = async () => {
    if (fmMsalInstance == null) {
        const settings = await getSettings();
        const clientId = settings.fmClientId;;
        const tenant = settings.tenantId;
        const serviceCustomDomainName = settings.serviceCustomDomainName;
        const fMappIdUriWithScope = settings.fMappIdUriWithScope;

        const msalConfig = {
            auth: {
                clientId: clientId,
                authority: "https://login.microsoftonline.com/".concat(tenant),
                redirectUri: window.location.origin,
            },
            system: {
                allowRedirectInIframe: true
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false,
            }
        };

        fmMsalInstance = new PublicClientApplication(msalConfig);
        fmMsalInstance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
                fmMsalInstance.setActiveAccount(event.payload.account);
            }
        }, error => {
            console.log("FM addEventCallback failed");
            console.log('error', error);
        });
        await fmMsalInstance.handleRedirectPromise()
            .then(async (tokenResponse) => {
                if (!tokenResponse) {
                    const accounts = fmMsalInstance.getAllAccounts();
                    if (accounts.length === 0) {
                        console.log("FM. handleRedirectPromise, loginRedirect");
                        await fmMsalInstance.loginRedirect({ scopes: [fMappIdUriWithScope] });
                    }
                } else {
                    fmMsalInstance.setActiveAccount(tokenResponse.account);
                    return fmMsalInstance;
                }
            })
            .catch(err => {
                console.error("FM. Failed to handleRedirectPromise", err);
            });

        const accounts = fmMsalInstance.getAllAccounts();
        if (accounts.length === 0) {
            console.log("FM. No user signed in, loginRedirect");
            await fmMsalInstance.loginRedirect({ scopes: [fMappIdUriWithScope] });
        }
    }

    return fmMsalInstance;
};

export const fmAuthToken = async () => {
    const fmMsalInstance = await fmAuthConfig();
    const settings = await getSettings();
    const activeAccount = fmMsalInstance.getActiveAccount();
    const fMappIdUriWithScope = settings.fMappIdUriWithScope;

    if (!activeAccount) {
        await fmMsalInstance.loginRedirect({ scopes: [fMappIdUriWithScope] });
    }

    const request = {
        scopes: [fMappIdUriWithScope],
        account: activeAccount
    };

    return await fmMsalInstance.acquireTokenSilent(request);
}
